import { useState, useEffect, useMemo } from "react";
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { LineChartData } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { LEGEND_BOTTOM } from '@/pages/intelligence/pages/TopCharts/_config/echarts';

export default function useRPDLineCharts(metric: string, lineData: any[], dateType: string): LineChartData {

  // 折线图 相关配置
  // 折线图 y轴数据
  const [lineSeriesData, setLineSeriesData] = useState<any>([]);
  // 折线图 图例
  const [lineLegendData, setLineLegendData] = useState<any[]>([]);
  // 折线图 x轴数据
  const [lineXAxisData, setLineXAxisData] = useState<string[]>([]);
  const [lineLegendSelected, setLineLegendSelected] = useState({});

  // 获取 lineSeriesData
  const createLineSeriesItemData = (data: any) => {
    return {
      type: 'line',
      name: data.name,
      symbol: 'circle',
      data: data?.history?.map((item: any) => [showTimeByDateType(item?.time, dateType), item?.value]) || [],
      cover: data.cover,
    };
  };

  // 获取 lineLegendSelected
  const createLineLegendSelected = (data: any): string => data?.name;

  // 获取 lineLegendData
  const createLineLegendData = (data: any) => {
    return {
      name: data?.name,
      icon: 'circle',
    };
  };

  // 获取折线图 lineSeriesData、lineLegendSelected、lineLegendData配置
  const createLineChartOptions = (data: any): any => {
    let series: any[] = [];
    let xAxis = [];
    let legendSelected: any = {};
    let legendData: any[] = [];

    try {
      let temp = data[metric];
      xAxis = temp[0].history.map((v: any) => showTimeByDateType(v?.time, dateType));
      temp.forEach((item: any) => {
        const serieName = createLineLegendSelected(item);
        series.push(createLineSeriesItemData(item));
        serieName && (legendSelected[serieName] = true);
        legendData.push(createLineLegendData(item));
      });
    } catch (e) {
      series = [];
      xAxis = [];
      legendSelected = {};
      legendData = [];
    }

    return { series, xAxis, legendSelected, legendData };
  };

  // y轴label格式化
  const lineYAxisFormatter = (value: string): string => `${newMathFormat(value, true)}`;


  const lineLegendsCustomMade = useMemo(() => {
    return {
      type: 'scroll',
      orient: 'horizontal', //横向
      pageIconColor: '#000', //翻页箭头颜色
      // selectedMode: false,
      pageIconSize: 12,
      pageTextStyle: {
        color: '#000', //翻页数字颜色
      }, //翻页数字设置
      show: true,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      inactiveColor: '#ccc', //关闭时图例颜色
      inactiveBorderWidth: 0,
      inactiveBorderColor: '#ffffff', //默认存在#ccc，看起来会比设置的icon图例大小有区别
      borderWidth: 0,
      // bottom: 0,
      bottom: LEGEND_BOTTOM,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
        // padding: [0, 30, 0, 0],
      },
      data: [...lineLegendData],
      selected: { ...lineLegendSelected },
      itemGap: 20,
    };
  }, [lineLegendData, lineLegendSelected]);


  useEffect(() => {
    const { series, xAxis, legendSelected, legendData } = createLineChartOptions(lineData);
    setLineSeriesData(series);
    setLineXAxisData(xAxis);
    setLineLegendSelected(legendSelected);
    setLineLegendData(legendData);
  }, [metric, lineData]);

  return {
    seriesData: lineSeriesData,
    xAxisData: lineXAxisData,
    yAxisFormatter: lineYAxisFormatter,
    lineLegendsCustomMade,
  };
}
